import { useHistory } from 'react-router-dom';
import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { toggle } from 'libs/util/boolean';
import { getColumns } from './schema';
import { getDefaultAction } from './schema';
import { Icon } from 'components/Icon';
import { React } from 'libs/react';
import './TableStackItem.scss';
/**
 * @component TableStackItem
 * @since 1.0.0
 * @hidden
 */
export function TableStackItem(props) {
    let { style, value, schema, primaryColumn, actionsColumn } = Object.assign({}, props);
    const history = useHistory();
    const [opened, setOpened] = useState(false);
    /**
     * @function render
     * @since 1.0.0
     * @hidden
     */
    function render(column) {
        const renderer = schema[column];
        if (renderer) {
            return renderer.render(value);
        }
        return '';
    }
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        setOpened(toggle);
    }
    const columns = getColumns(schema);
    if (primaryColumn == null) {
        primaryColumn = Object.keys(schema)[0];
    }
    const className = classNames('table-stack-item', 'table-stack-item--' + style, { 'table-stack-item--is-opened': opened }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "table-stack-item-head", onClick: onClick },
            React.createElement("div", { className: "table-stack-item-picto" },
                React.createElement(Icon, { value: "chevron-right" })),
            React.createElement("div", { className: "table-stack-item-title" }, render(primaryColumn)),
            React.createElement("div", { className: "table-stack-item-action" },
                React.createElement(Icon, { value: "arrow-right", onClick: () => history.push(getDefaultAction(schema, value)) }))),
        React.createElement("div", { className: "table-stack-item-body" },
            React.createElement("table", { className: "table-stack-item-fields" },
                React.createElement("tbody", null, columns.map((column) => {
                    var _a, _b;
                    let label = ((_a = schema[column]) === null || _a === void 0 ? void 0 : _a.header) || ((_b = schema[column]) === null || _b === void 0 ? void 0 : _b.footer);
                    if (column == actionsColumn) {
                        label = t('Actions');
                    }
                    if (label) {
                        return (React.createElement("tr", { key: column, className: "table-stack-item-field" },
                            React.createElement("td", { className: "table-stack-item-field-label" }, label),
                            React.createElement("td", { className: "table-stack-item-field-value" }, render(column))));
                    }
                    return (React.createElement("tr", { key: column, className: "table-stack-item-field" },
                        React.createElement("td", { colSpan: 2, className: "table-stack-item-field-value" }, render(column))));
                }))))));
}
